import DataSourceDelete from './DataSourceDelete';

export default DataSourceDelete;
